import { render, staticRenderFns } from "./VerifiedComplaint.vue?vue&type=template&id=eaef6f7a&"
import script from "./VerifiedComplaint.vue?vue&type=script&lang=js&"
export * from "./VerifiedComplaint.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedComplaint.vue?vue&type=style&index=0&id=eaef6f7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports